import * as S from './styled'
import { IMaskInput } from 'react-imask';
import { useForm, SubmitHandler, Controller } from 'react-hook-form';
//hooks
import apiRequest from '../../../../hooks/apiRequest';
import useLoading from '../../../../hooks/useLoading';
//Components
import LayoutModal from '../../../../components/LayoutModal'
//Interfaces
import { Inputs } from 'Interfaces/ISupllier';

interface ICreate {
  isOpenModal: boolean;
  setModalClose: () => void;
  refreshFrames: () => void;
}

export default function Create({
  isOpenModal,
  setModalClose,
  refreshFrames
}: ICreate) {
  const {
    register,
    handleSubmit: handleFormSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm<Inputs>();

  const { isLoading, startLoading, stopLoading } = useLoading();

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    startLoading();
    try {
      const formattedData = {
        ...data,
        name: data.name.toUpperCase(), // Aqui você força caixa alta
      };

      const response = await apiRequest('supplier', 'POST', formattedData);
      if (response.status === 201) {
        alert("Fornecedor criado com sucesso!");
        refreshFrames();
        onClose();
      }
    } catch (error: any) {
      alert(error.message || "Ocorreu um erro ao criar o fornecedor.");
    } finally {
      stopLoading();
    }
  };

  const onClose = () => {
    setModalClose();
    reset();
  }

  if (isOpenModal) {
    return (
      <LayoutModal
        statusLoad={isLoading}
        title="Registrar Fornecedor"
        subTitle="Cadastre um novo fornecedor em sua base de dados."
        setModalClose={onClose}
        submiteModal={handleFormSubmit(onSubmit)}

        nameIconMinimize={'Registrar Fornecedor'}
      >
        <S.Container>
          <S.FormInput>
            <S.Label>
              Nome do Fornecedor
              <span>*</span>
            </S.Label>
            <S.Input
              placeholder="Informe o fornecedor"
              type="text"
              {...register("name", { required: true })}
            />
            {errors.name && <S.InforErro>Campo Obrigatório</S.InforErro>}
          </S.FormInput>

          <S.FormInput>
            <S.Label>Contato</S.Label>
            <Controller
              name="contact"
              control={control}
              render={({ field }) => (
                <IMaskInput
                  className="imask"
                  id="phone_primary"
                  mask="(00) 00000-0000"
                  placeholder="(99) 99999-9999"
                  {...field}
                />
              )}
            />
          </S.FormInput>

          <S.FormInput>
            <S.Label>E-mail</S.Label>
            <S.Input
              placeholder="exemplo@gmail.com"
              type="email"
              {...register("email")}
            />
          </S.FormInput>

          <S.FormInput>
            <S.Label>Descrição</S.Label>
            <S.TextArea
              placeholder="Campo Opcional"
              rows={2}
              {...register("description")}
            />
          </S.FormInput>
        </S.Container>
      </LayoutModal>
    );
  }
  return null;
}